import React from 'react';
import usePresence from '../../hooks/usePresence';
import Colors from '../../styles/colors';
import { View } from "react-native";

export function PresenceIndicator({username, style}) {
    const status = usePresence(username);

    let borderColor = Colors.onBackground3;
    let backgroundColor = Colors.onBackgroundBorder;

    if (status == 'online') {
        borderColor = Colors.success3;
        backgroundColor = Colors.success;
    }  else if (status === 'away') {
        borderColor = Colors.secondary2;
        backgroundColor = Colors.secondary3;
    }


    return (
        <View style={{
            borderWidth: 1,
            borderColor: borderColor,
            borderRadius: 100,
            height: 10,
            width: 10,
            backgroundColor: backgroundColor,
            ...(style ?? {})
        }}></View>
    );
}